import type { Middleware } from '@reduxjs/toolkit'

import { isAction } from '../actionTypeGuard'
import { getSettings } from '../selectors'
import type { IProjectContext } from '../types'
import { setEditorSettings } from '../useEditorSettings'

export const localStorage: Middleware = (store) => (next) => (action) => {
  const result = next(action)
  const nextState = store.getState().project as IProjectContext
  const settings = getSettings(nextState)

  if (isAction(action, 'setSettings')) {
    setEditorSettings(settings)
  }

  return result
}
